import React from 'react'

import { Icon } from '@fourthwall/components'
import { PhotoIcon } from '@fourthwall/icons'

import * as S from './styled'

type Props = {
  url?: string
  size?: 'small' | 'large'
}

export const EmojiPreview = ({ size = 'small', url }: Props) => (
  <S.Container size={size}>
    {url ? <S.Emoji src={url} /> : <Icon component={PhotoIcon} height={24} />}
  </S.Container>
)
